import { BsCircleFill } from "react-icons/bs";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const data = [
  { name: "Laptop", value: 100, fill: "#8884d8" },
  { name: "Mobile", value: 200, fill: "#82ca9d" },
  { name: "Camera", value: 300, fill: "#ffc658" },
];

const COLORS = ["#8884d8", "#82ca9d", "#ffc658"];

const PieCharts = () => (
  <div className="grid grid-cols-1 grid-rows-6 h-full w-full">
    <div className=" row-span-1 flex flex-row justify-between">
      <h1 className="font-semibold m-5">Sales By Category</h1>
      <div className="mx-3 mt-2">
        {data.map((name) => (
          <h1 key={name.fill} className=" font-semibold ">
            <span>
              <BsCircleFill
                style={{ color: name.fill }}
                className={` inline-block mr-1 text-xs`}
              />
            </span>
            {name.name}
          </h1>
        ))}
      </div>
    </div>
    <div className=" row-span-5 flex-1 w-full h-full">
      <ResponsiveContainer>
        <PieChart width={600} height={500}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.fill || COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  </div>
);
export default PieCharts;
